import { render } from "./ActionContent.vue?vue&type=template&id=56821c2e"
import script from "./ActionContent.vue?vue&type=script&lang=js"
export * from "./ActionContent.vue?vue&type=script&lang=js"

import "./ActionContent.vue?vue&type=style&index=0&id=56821c2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__